import { Box, Button } from '@factorialco/deprecated-design-system'
import { DocumentsDataTableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import MoreActions from 'modules/documents/components/ActionsDatatable/MoreActions'
import VisibilityIcon from 'modules/documents/components/ActionsDatatable/VisibilityIcon'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import { SPACE, SPACES } from 'modules/documents/lib/constants'

interface Props {
  document: Document
  onNavigationClick: (documentId: string) => void
  space: SPACE
  deleteFeatureEnabled: boolean
}

const ActionsDatatable = ({ document, onNavigationClick, space, deleteFeatureEnabled }: Props) => {
  const { selectedRows } = useDataTable<DocumentsDataTableQuery>()
  const selectedIds = [...selectedRows]
  const isInternalSpace = space === SPACES.COMPANY_INTERNAL

  const navigateToDocument = () => {
    onNavigationClick(document.id)
  }

  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      {!isInternalSpace && (
        <VisibilityIcon document={document} disabled={selectedIds.includes(document.id)} />
      )}
      <MoreActions
        document={document}
        fromDataTable
        disabled={selectedIds.includes(document.id)}
        space={space}
        deleteFeatureEnabled={deleteFeatureEnabled}
      />
      <Button
        type="secondary"
        aria-label={i18n.t('common.view_document')}
        onClick={navigateToDocument}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default ActionsDatatable
